
import { forwardRef, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { DisplayListPagination, DisplaySearchCriteria, PeriodSelectionWithCustom } from '../../../components/TapUi';
import Loader from '../../../components/ui/Loader/Loader';
import TapSelect from '../../../components/ui/TapSelect';
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import HttpAPICall from '../../../services/HttpAPICall';
import { HRM_API_BASE_URL_2, INVENTORY_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import TapHelper from '../../../services/TapHelper';
import TapIcon from '../../../services/TapIcon';
import PageHeader from '../../includes/PageHeader';
import DownloadFile from '../../../services/DownloadFile';
import { toast } from 'react-toastify';
import swal from "sweetalert";
import moment from 'moment';
import InputEmployeeSearch from '../../includes/ui/InputEmployeeSearch';
import InputCustomerSearch from '../../includes/ui/InputCustomerSearch';
import InputDealSearch from '../../salesCrm/includes/InputDealSearch';
import SalesOrderDetailModal from '../../salesCrm/salesOrder/SalesOrderDetailModal';
const ItemWiseSalesOrder = forwardRef((props) => {
    const criteriaRef = useRef()
    const PODetailModalRef = useRef(null)


    let initListData = {
        loading: false,
        show: false,
        items: [],
        meta: null,
        vouchers: [],
        items_meta: [],
        warehouses: [],
        customers: [],
        statuses: [],
        page: 1
    };

    let initFormData = {
        show: true,
        per_page: 5,
        form_data_loaded: false,
        loading: false,
        downloading: false,
        periods: [],
        date_range: null,
        date_range_start: null,
        date_range_end: null,
        search_transaction_id: '',
        date_range: null,
        date_range_start: null,
        date_range_end: null,
        search_item_ids: [],
        search_item_tags: [],
        search_status_ids: [],
        search_priority: '',
        tagged_user_ids: [],
        search_deal_ids: [],
        allStatusOptions: [],
        allPriorityOptions: [],
        search_warehouse_ids: [],
        all_warehouses: [],
        allItemTags: [],
        search_customer_ids: [],
    };

    let formDataLabel = {
        search_transaction_id: 'Transaction ID : ',
        search_warehouse_ids: 'Warehouses : ',
        date_range: 'Date Range : ',
        search_item_ids: 'Items : ',
        search_item_tags: 'Item Tags : ',
        search_status_ids: 'Search Status : ',
        search_priority: 'Search Priority : ',
        tagged_user_ids: 'Tagged Users : ',
        search_deal_ids: 'Deals : ',
        search_customer_ids: 'Customer : ',

    };

    const access_token = useSelector(state => state.auth.access_token);
    const all_period = useSelector(state => state.app.all_periods ? state.app.all_periods : []);
    const all_warehouse = useSelector(state => state.app.warehouses ? state.app.warehouses : []);
    const item_tag = useSelector(state => state.app.item_tags ? state.app.item_tags : []);

    const [criteriaHeight, setCriteriaHeight] = useState(0)
    const [searchedCustomer, setSearchedCustomer] = useState([])
    const [searchedDeals, setSearchedDeals] = useState([])
    const [SalesOrderData, setSalesOrderData] = useState({ ...initListData });
    const [formData, setFormData] = useState({ ...initFormData });
    const [searchedElems, setSearchedElems] = useState([]);

    let reportUrl = INVENTORY_API_BASE_URL_2 + "/report/item_wise_sales_order";
    const formDataUrl = INVENTORY_API_BASE_URL_2 + '/sales_order/form_data';

    useEffect(() => {
        toggleFilterForm(true);
    }, []);

    const updateCriteriaHeight = () => {
        if (criteriaRef.current) {
            const height = criteriaRef.current.offsetHeight;
            if (criteriaHeight !== height) {
                setCriteriaHeight(height)
            }
        }
    };
    useEffect(() => {
        updateCriteriaHeight()

        if (formData.show && !formData.form_data_loaded) {
            loadFormData();
        }
    }, [formData.show]);

    const toggleFilterForm = (show) => {
        setFormData(pd => ({ ...pd, show: show }))
        if (document.getElementById('pageTbl')) {
            document.getElementById('pageTbl').scroll({ top: 0, behavior: 'smooth' });
        }
    }
    const soDetailModalInit          =       (req_item_id)           =>      {
        PODetailModalRef.current.modalSOInit(req_item_id);  
    }
    const loadFormData = () => {
        setFormData(pre => ({ ...pre, loading: true }));
        let all_periods = [...all_period, { key: 'custom', display: 'Custom Date Range' }]
        HttpAPICall.withAthorization("GET", formDataUrl, access_token, null, null, (resp) => {
            let formData = resp.data
            setFormData(pre => ({
                ...pre,
                form_data_loaded: true,
                loading: false,
                allStatusOptions: formData && formData.status && formData.status.length > 0 ? formData.status.map((s) => { return { value: s.id, label: s.name }; }) : [],
                allPriorityOptions: formData && formData.priorities && formData.priorities.length > 0 ? formData.priorities.map((s) => { return { value: s.key, label: s.name }; }) : [],
                allUsers: formData && formData.users ? formData.users.map((s) => { return { value: s.id, label: s.full_name, site_ids: s.linked_sites }; }) : [],
                allPOTypes: formData && formData.purchase_order_type && formData.purchase_order_type.length > 0 ? formData.purchase_order_type.map((s) => { return { value: s.key, label: s.name }; }) : [],
                all_warehouses: all_warehouse ? all_warehouse.map((m) => { return { value: m.id, label: `${m.name} (${m.code})` } }) : [],
                all_periods: all_periods,
                allItemTags: item_tag && item_tag.length > 0 ? item_tag.map((s) => { return { value: s.id, label: s.name }; }) : [],
            }))
        }).then(() => setFormData(pre => ({ ...pre, loading: false })));
    }

    const closeReport = () => props.history.push({ pathname: `/report` })
    
    const submitSearchFormHandler = (e) => {
        e.preventDefault();
        toggleFilterForm(false);
        let searchedElems = [];
        let searchParams = {};
        Object.keys(formData).map((key) => {
            let label = formDataLabel[key];
            let value = formData[key];

            if (value && value.length > 0) {
                searchParams[key] = value;
                if (label) {

                    let show_val = value;

                    if (key == 'date_range') {
                        let start_range = moment(formData.date_range_start).format('DD-MMM-YYYY');
                        let end_range = moment(formData.date_range_end).format('DD-MMM-YYYY')
                        let display_custom = `Custom Date Range (${start_range} - ${end_range})`
                        show_val = formData.all_periods.filter((s) => value.includes(s.key)).map(s => s.display_with_date ? s.display_with_date : display_custom);
                    }
                    if (key == 'search_transaction_id') {
                        show_val = formData ? formData.search_transaction_id : '';
                    }
                    if (key == 'search_status_ids') {
                        show_val = formData.allStatusOptions.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    }
                    if (key == 'search_priority') {
                        show_val = formData.allPriorityOptions.filter((s) => value.includes(s.value)).map(s => s.label);
                    }
                    if (key == 'search_warehouse_ids') {
                        show_val = formData.all_warehouses.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    }
                    if (key == 'search_customer_ids') {
                        show_val = searchedCustomer ? searchedCustomer.map(s => s.display_label).join(', ') : '';
                    }
                    if (key == 'search_deal_ids') {
                        show_val = searchedDeals ? searchedDeals.map(s => s.display_label).join(', ') : '';
                    }
                    searchedElems.push(label + `<b>${show_val}</b>`);
                }
            }
        });
        setSearchedElems(searchedElems);
        loadItemsData(1);
    }

    const loadItemsData = (page = 1) => {
        setSalesOrderData(pd => ({ ...pd, show: true, loading: true, page: page }));
        let params = {
            action: 'data',
            page: page,
            ...TapHelper.pick(formData, ['date_range', 'date_range_start', 'date_range_end', "search_status_ids", 'search_priority', 'search_warehouse_ids', 'search_customer_ids', 'search_transaction_id', 'search_deal_ids'])
        };
        HttpAPICall.withAthorization('GET', reportUrl, access_token, params, {}, (response) => {
            let respData = response.data || {};
            // New API shape: { list: { data: [...], ... }, vouchers: [...], items: [...], warehouses: [...], customers: [...], status: [...] }
            const list = respData.list || {};
            const items = list.data || [];
            const meta = TapHelper.pick(list, ['from', 'to', 'total', 'last_page', 'per_page', 'current_page']);
            setSalesOrderData(pd => ({ ...pd,
                items: items,
                meta: meta,
                vouchers: respData.vouchers || [],
                items_meta: respData.items || [],
                warehouses: respData.warehouses || [],
                customers: respData.customers || [],
                statuses: respData.status || [],
            }));
        }).then(() => {
            setSalesOrderData(pd => ({ ...pd, loading: false }));
        });

    }
    const activityExceldownload = () => {
        swal({
            title: "Download",
            text: "The download will be for trailing three months period, in case you want a different criteria then please use search button before downloading.",
            icon: "warning",
            // dangerMode: true,
            buttons: ["No", "Yes"],
        })
            .then(willDelete => {
                if (willDelete) {
                    reportDownloadHandler()
                }
            });
    }

    const reportDownloadHandler = () => {
        const paramsFormData = { ...TapHelper.pick(formData, ['date_range', 'date_range_start', 'date_range_end', "search_status_ids", 'search_priority', 'search_warehouse_ids', 'search_customer_ids', 'search_transaction_id', 'search_deal_ids']) };
        let params = {
            ...paramsFormData,
            action: 'download',
            date_range: paramsFormData.date_range ? paramsFormData.date_range : 'current_month',
        };
        setSalesOrderData(pd => ({ ...pd, downloading: true }));
        HttpAPICall.withAthorization('GET', reportUrl, access_token, params, {}, (response) => {
            DownloadFile.file(response.data.file_path,response.data.msg,response.data.navigation,props)
        }).then(() => {
            setSalesOrderData(pd => ({ ...pd, downloading: false }));
        }).catch((err) => {
            toast.error(err.response?.data?.message, { position: toast.POSITION.TOP_CENTER })
        });
    }

    const formInputHandler = (e, afterCallbackFn = null) => {
        const { name, value, type } = e.target;
        const newValue = type === 'number' ? (value ? Number(value) : value) : value;

        setFormData(prevState => ({
            ...prevState,
            [name]: newValue
        }));

        if (afterCallbackFn) {
            afterCallbackFn();
        }
    };

    const filterFormJsx = () => {
        return <form onSubmit={submitSearchFormHandler} className='py-3'>
            <div className="row my-3">
                <label className="col-sm-3 col-form-label text-end">Sales Order Number</label>
                <div className="col-sm-6">
                    <input
                        name="search_transaction_id"
                        type="text"
                        value={formData.search_transaction_id}
                        onChange={formInputHandler}
                        className="form-control form-control-sm"
                        autoComplete="off"
                        placeholder="Please Enter transaction id"
                    />
                </div>
            </div>
            <div className="row my-3 align-items-center">
                <label className="col-sm-3 col-form-label col-form-label-sm  text-end">Status</label>
                <div className="col-sm-6">
                    <TapSelect
                        options={formData.allStatusOptions}
                        changeEvent={(selectedOptions) => {
                            setFormData(prev => ({
                                ...prev,
                                search_status_ids: selectedOptions ? selectedOptions.map(opt => opt.value) : []
                            }));
                        }}
                        value={formData.allStatusOptions.filter(option =>
                            formData.search_status_ids.includes(option.value)
                        )}
                        isSearchable={true}
                        isMulti={true}
                        isClearable={true}
                        placeholder="Select Status"
                        containerHeight="30px"
                        fontSize="93%"
                    />
                </div>
            </div>
            <div className="row my-3 align-items-center">
                <label className="col-sm-3 col-form-label col-form-label-sm  text-end">Priority</label>
                <div className="col-sm-6">
                    <TapSelect
                        options={formData.allPriorityOptions}
                        changeEvent={(selectedOption) => {
                            setFormData(prev => ({
                                ...prev,
                                search_priority: selectedOption ? selectedOption.value : ''
                            }));
                        }}
                        value={formData.allPriorityOptions.find(option =>
                            option.value === formData.search_priority
                        )}
                        isSearchable={true}
                        isClearable={true}
                        placeholder="Select Priority"
                        containerHeight="30px"
                        fontSize="93%"
                    />
                </div>


            </div>
            <div className="row my-3 align-items-center">
                <label className="col-sm-3 col-form-label col-form-label-sm  text-end">Warehouse</label>
                <div className="col-sm-6">
                    <TapSelect
                        options={formData.all_warehouses}
                        changeEvent={(selectedOptions) => {
                            setFormData(prev => ({
                                ...prev,
                                search_warehouse_ids: selectedOptions ? selectedOptions.map(opt => opt.value) : []
                            }));
                        }}
                        value={formData.all_warehouses.filter(option =>
                            formData.search_warehouse_ids.includes(option.value)
                        )}
                        isSearchable={true}
                        isMulti={true}
                        isClearable={true}
                        placeholder="Select Warehouses"
                        containerHeight="30px"
                        fontSize="93%"
                    />
                </div>
            </div>
            <div className="row my-3 align-items-center">
                <label className="col-sm-3 col-form-label col-form-label-sm  text-end">Customer</label>
                <div className="col-sm-6">
                    <InputCustomerSearch
                        changeEvent={(selectedOptions) => {
                            setFormData(prev => ({
                                ...prev,
                                search_customer_ids: selectedOptions ? selectedOptions.map(opt => opt.value) : []
                            }));
                            setSearchedCustomer(selectedOptions || []);
                        }}
                        isMulti={true}
                        value={searchedCustomer}
                        containerHeight="30px"
                        fontSize="93%"
                    />
                </div>
            </div>
            <div className="row my-3 align-items-center">
                <label className="col-sm-3 col-form-label col-form-label-sm  text-end">Deals</label>
                <div className="col-sm-6">
                    <InputDealSearch
                        changeEvent={(selectedOptions) => {
                            setFormData(prev => ({
                                ...prev,
                                search_deal_ids: selectedOptions ? selectedOptions.map(opt => opt.value) : []
                            }));
                            setSearchedDeals(selectedOptions || []);
                        }}
                        isMulti={true}
                        value={searchedDeals}
                        containerHeight="30px"
                        fontSize="93%"
                    />
                </div>
            </div>



            <div className="row my-3">
                <label className="col-sm-3 col-form-label-sm text-end require">Transaction Period</label>
                <div className="col-sm-6">
                    <PeriodSelectionWithCustom
                        periods={formData.all_periods ? formData.all_periods : []}
                        className="form-control-sm"
                        onSelectPeriod={(period, startDate, endDate) => {
                            setFormData(d => ({
                                ...d,
                                date_range: period,
                                date_range_start: startDate ? startDate : null,
                                date_range_end: endDate ? endDate : null
                            }))
                        }}
                        containerHeight="30px"
                        fontSize="93%"
                        required={true}
                        value={formData.date_range}
                        startDate={formData.date_range_start}
                        endDate={formData.date_range_end}
                    />
                </div>
            </div>
            <div className="row my-4  border-bottom">
                <div className="pb-3 col-sm-9 text-end">
                    <div className='d-flex justify-content-end align-items-center gap-2'>
                        <button type="submit" className="btn btn-primary px-4">Show Report</button>
                    </div>
                </div>
            </div>
        </form>
    }

    const voucherListJsx = () => {
        return <>
            <div ref={criteriaRef}
                style={{ position: 'sticky', top: 0, background: 'white', }}>
                <DisplaySearchCriteria searchedElems={searchedElems} />
            </div>
            <table className="table table-sm table-bordered align-middle bg-white">
                <thead className="align-middle table-secondary" style={{
                    top: `${criteriaHeight}px`,
                    position: 'sticky',
                }}>
                    <tr className='text-center'>
                        <th scope="col" style={{ width: "4%" }}>S.No</th>
                        <th scope="col" style={{ width: "10%" }}>Sales Order</th>
                        <th scope="col" style={{ width: "8%" }}>Date</th>
                        <th scope="col" style={{ width: "12%" }}>Warehouse</th>
                        <th scope="col" style={{ width: "12%" }}>Customer</th>
                        <th scope="col" style={{ width: "18%" }}>Item</th>
                        <th scope="col" style={{ width: "6%" }}>Qty</th>
                        <th scope="col" style={{ width: "6%" }}>Pending</th>
                        <th scope="col" style={{ width: "8%" }} className="text-end">Amount</th>
                        <th scope="col" style={{ width: "6%" }}>Currency</th>
                        <th scope="col" style={{ width: "8%" }}>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {SalesOrderData.loading ? (
                        <tr><td className='text-center' colSpan={11}><Loader /></td></tr>
                    ) : (SalesOrderData.items && SalesOrderData.items.length > 0) ? (
                        SalesOrderData.items.map((item, index) => {
                            // find matching voucher and lookups
                            const vouchers = SalesOrderData.vouchers || [];
                            const warehouses = SalesOrderData.warehouses || [];
                            const customers = SalesOrderData.customers || [];
                            const statuses = SalesOrderData.statuses || [];
                            const voucher = vouchers.find(v => v.transaction_id === item.transaction_id || v.id === item.sales_order_id) || {};
                            const warehouse = warehouses.find(w => w.id === voucher.warehouse_id) || {};
                            const customer = customers.find(c => c.id === voucher.customer_id) || {};
                            const statusObj = statuses.find(s => s.id === voucher.status) || {};
                            const itemMeta = (SalesOrderData.items_meta || []).find(it => it.id === item.item_id) || {};

                            return <tr key={index} className='text-center'>
                                <td>{index + 1} </td>
                                <td onClick={() => soDetailModalInit(item.transaction_id)}><a hred="#" role="button" className='link-primary'>{item.transaction_id}</a></td>
                                <td>{voucher.transaction_date || '-'}</td>
                                <td>{warehouse.name || '-'}</td>
                                <td>{customer.name || '-'}</td>
                                <td className='text-start'>{itemMeta.name || item.item_id}</td>
                                <td>{item.qty || '-'}</td>
                                <td>{item.pending_qty || '-'}</td>
                                <td className='text-end'>{item.item_final_amount_vc || item.amount_with_discount_vc || '-'}</td>
                                <td>{item.currency || voucher.currency || '-'}</td>
                                <td>{statusObj.name || (voucher.status ? voucher.status : '-')}</td>
                            </tr>
                        })
                    ) : (
                        <tr><td className='text-center' colSpan={11}>No Records Found</td></tr>
                    )}
                    
                </tbody>
            </table>
            <DisplayListPagination meta={SalesOrderData.meta} onPageChange={(e) => loadItemsData(e.selected + 1)} />
        </>
    }

    const topRightHeaderJsx = () => {
        return <>
            <div className="text-end mt-2">
                <button type="button" disabled={SalesOrderData.downloading || SalesOrderData.loading || formData.loading} className="btn btn-secondary" onClick={() => toggleFilterForm(!formData.show)} >
                    Change Filter
                </button>
                {SalesOrderData.show && <button type="button" disabled={SalesOrderData.downloading || SalesOrderData.loading || formData.loading} className="btn btn-secondary" onClick={activityExceldownload}>
                    <TapIcon.FontAwesomeIcon icon={TapIcon.faDownload} />
                    {SalesOrderData.downloading && <TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin ms-2" />}
                </button>}
                <button type="button" className="btn btn-secondary mx-1" onClick={closeReport}>
                    <TapIcon.imageIcon icon={TapIcon.CloseIcon} className="img-fluid" alt="Close requisition" />
                </button>
            </div>
        </>
    }

    return <ApplicationLayout>
        <PageHeader title="Sales Order Report" name="Item Wise SO Report" rightTopHeadingJsx={topRightHeaderJsx()} />
        <div className="container-fluid pl5">
            <div className="page_containt row">
                <div id="pageTbl" className="pageTbl col-sm-12 pb-3">
                    <div className={["bg-white", formData.show ? 'tbShow' : 'tbHide'].join(" ")} >
                        {formData.loading ? <Loader /> : filterFormJsx()}
                    </div>
                    {SalesOrderData.show && voucherListJsx()}
                </div>
            </div>
        </div>
        <SalesOrderDetailModal parentProps={props} ref={PODetailModalRef}/>
    </ApplicationLayout>

});

export default ItemWiseSalesOrder;